import React, { useState, useEffect } from 'react';
import { Button, Input, message, Upload } from 'antd';
import BaseColumnInput from '../../../components/input/base_column_input';
import BaseDeleteFooter from '../../../components/footer/base_delete';
import { restApi, getFileHost, getFileUploadToken } from '../../../apis';
import TrainerPofileDetail from './trainer_profile_detail';
import { useNavigate } from 'react-router-dom'; 

const TrainerPofile = (props) => {
  // const [isRead, setRead] = useState(false); 
  const { trainerId, setTrainerName, setLoading, loading, ...rest } = props;
  const [messageApi, contextHolder] = message.useMessage();
  const [isRead, setRead] = useState(false);
  const [data, setData] = useState({
    carrier: null,
    centerIP: null,
    centerName: null,
    centerPhone: null,
    email: null,
    id: null,
    name: null,
    phone: null,
    photoKey: null,
    photoExt: null,
    photoPath: null,
    role: null,
  });

  const navigate = useNavigate(); // ← 추가


  // console.log('==11==>', props);
  useEffect(() => {
    // 로딩
    setLoading(true);
    // 데이터 가져오기
    (async (args) => {
      const response = await restApi.get(`/account/mypage/${trainerId}`);
      const account = response?.data?.payload?.account;
      if (account) {
        setTrainerName(account.name);
        setData((prev) => {
          return {
            ...prev,
            ...account,
          };
        });
      }
      setLoading(false);
    })();

    setTimeout(() => {
      setLoading(false);
    }, 5000);

  }, []);

  return (
    <>
      <div style={{ ...styles.container }}>
        <div style={{ ...styles.header }}>
          <div style={{ ...styles.title }}>{`트레이너프로필`}</div>
          {/* 
					<Button
            style={{ ...styles.botton_update }}
          >{`프로필 수정하기`}</Button>
				 */}
        </div>
        {/* ---------------------------------------------------------------------------------------------------- */}
        <TrainerPofileDetail data={data} />
      </div>
      <div style={{ marginTop: 24 }} />
      {/* ---------------------------------------------------------------------------------------------------- */}
      <BaseDeleteFooter
        title={`트레이너 계정 삭제`}
        boxTitle={`해당 트레이너 계정을 삭제하시겠습니까?`}
        boxContents={`삭제한 계정에 포함된 데이터(시퀀스/템포/강의)는 밸런스피터 DB로 종속되며, 한번 삭제한 트레이너 계정은 다시 복구할 수 업습니다. 정말 삭제하시겠습니까?`}
        buttonTitle={`트레이너 계정 삭제`}

        onDeleted={async () => {
          messageApi.info('트레이너 삭제에 성공했습니다.');
          const response = await restApi
            .delete(`/admin/trainer/${data.id}`, {
              params: { depth: null },
            })
            .then((v) => {
              if(v.data.message == 'OK') {
                navigate('/trainers');
              }
            });
        }}
      />
      {/* ---------------------------------------------------------------------------------------------------- */}
    </>
  );
};

const styles = {
  container: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    alignItems: 'flex-start',
    background: '#FFF',
    boxShadow: '0px 4px 18px rgba(75, 70, 92, 0.1)',
    borderRadius: 6,
    padding: 0,

    // font
    fontFamily: 'Public Sans',
    fontStyle: 'normal',
    /*
    fontWeight: 600,
    fontSize: '1.3rem',
    lineHeight: '1.5rem',
    letterSpacing: 1,
    textTransform: 'uppercase',
		*/
  },

  header: {
    display: 'flex',
    width: '100%',
    height: '6.8rem',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #DBDADE',
    padding: '0rem 2.4rem 0rem 2.4rem',
    background: '#FFFFFF',
  },
  title: {
    display: 'flex',
    width: '50rem',
    // flexDirection: 'row',
    alignItems: 'center',
    // justifyContent: 'center',

    fontWeight: 600,
    fontSize: '1.8rem',
    lineHeight: '2.4rem',
    // letterSpacing: 1,
    // textTransform: 'uppercase',
  },
  col_title: {
    display: 'flex',
    // flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    //font
    fontWeight: 400,
    fontSize: '1.3rem',
    lineHeight: '1.5rem',
  },
  botton_update: {
    display: 'flex',
    width: '14.3rem',
    height: '3.8rem',
    alignItems: 'center',
    justifyContent: 'center',

    border: 0,
    background: `linear-gradient(72.47deg, #7367F0 22.16%, rgba(115, 103, 240, 0.7) 76.47%)`,
    // ...item.style,
    color: '#FFF',
  },
  row: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0rem 2.4rem 0rem 2.4rem',
    background: '#FFFFFF',
  },
  column: {
    display: 'flex',
    // height: '100%',
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0rem 0.9rem 0rem 0.9rem',
    background: '#FFFFFF',
  },
};
export default TrainerPofile;
